import PageSetup from "../../components/PageSetup";
import TestsContainer from "./CategoriesList";

export default function TestsByTeacher() {
    return (
        <PageSetup>
            <TestsContainer />
        </PageSetup>
    )
}